import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { protectedBaseUrl } from '@app/services/api/api.service';
import { AuthService } from '@app/services/auth/auth.service';

let isSigningOut = false;

/** Clears a stale Cognito session when protected GraphQL returns 401. */
export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url !== protectedBaseUrl) {
    return next(req);
  }

  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        authService.user?.token &&
        !isSigningOut
      ) {
        isSigningOut = true;
        void authService.signOut();
      }

      return throwError(() => error);
    }),
  );
};
